/* eslint-disable react/no-array-index-key, react/no-danger */
import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { scroller } from 'react-scroll';
import Headroom from 'react-headroom';
import { candidateLogout } from '../../services/AuthService';
import firebase from 'firebase/compat/app';
import CandidateInfo from '../candidateinfo/candidateinfo';
import { NavLink, Link } from "react-router-dom";
import bgimage from "../../../src/assets/img/images/teamanics_logo_4.png";
import bgimage1 from "../../../src/assets/img/login/loginimg.png";
import userImage from "../../../src/assets/img/profiles/user.png";

import
{
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
} from 'reactstrap';
import
{
    Row,
    Input,
    FormGroup,
    Label,
    CustomInput,
    Button,
    Form,
} from "reactstrap";
const Header = () =>
{
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const refRowHome = useRef(null);
    const refSectionHome = useRef(null);
    const refSectionFooter = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const onWindowResize = (event) =>
    {
        const homeRect = refRowHome.current.getBoundingClientRect();

        const homeSection = refSectionHome.current;
        homeSection.style.backgroundPositionX = `${homeRect.x - 580}px`;

        const footerSection = refSectionFooter.current;
        footerSection.style.backgroundPositionX = `${event.target.innerWidth - homeRect.x - 2000
            }px`;

        if (event.target.innerWidth >= 992) {
            setShowMobileMenu(false);
        }
    };

    const onWindowClick = () =>
    {
        setShowMobileMenu(false);
    };

    const onWindowScroll = () =>
    {
        setShowMobileMenu(false);
    };

    useEffect(() =>
    {
        window.addEventListener('scroll', onWindowScroll);
        window.addEventListener('resize', onWindowResize);
        window.addEventListener('click', onWindowClick);

        document.body.classList.add('no-footer');

        if (window.localStorage.getItem("name") != null || window.localStorage.getItem("name") !== '') {
            setFirstName(window.localStorage.getItem("name"))
        }

        if (window.localStorage.getItem("lastName") !== null || window.localStorage.getItem("lastName") !== '') {
            setLastName(window.localStorage.getItem("lastName"))
        }

        return () =>
        {
            window.removeEventListener('scroll', onWindowScroll);
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('click', onWindowClick);
            document.body.classList.remove('no-footer');
        };
    }, []);



    const handleLogout = () =>
    {
        candidateLogout().then((response) =>
        {
            try {
                if (response.message != null) {
                    if (response.data.error_message !== "") {
                    }
                } else {
                    firebase
                        .auth()
                        .signOut()
                        .then(function ()
                        {
                            window.localStorage.removeItem("user");
                            window.localStorage.removeItem("account");
                            //window.localStorage.removeItem("profile");
                            window.localStorage.clear();
                            sessionStorage.clear();
                            window.location.href = "/";
                        })
                        .catch(function ()
                        {
                        });
                }
            } catch (err) {
            }
        }).catch((error) =>
        {
            firebase
                .auth()
                .signOut()
                .then(function ()
                {
                    window.localStorage.removeItem("user");
                    window.localStorage.removeItem("account");
                    window.localStorage.clear();
                     sessionStorage.clear();
                    // window.localStorage.clear();
                    window.location.href = "/";
                })
                .catch(function ()
                {
                });
        });
    };

    const handleMyAccount = () =>
    {
        <CandidateInfo />
    }

    return (
        <nav className="navbar
         fixed-top 
         bg-light p-3"
         ref={refRowHome}>

            <a className="menu-button d-none d-md-block t-header-left-padding t-longin-header" href="/">
                <img className="  " alt="hero" src={bgimage} width="150px" />
            </a>

            <div className="navbar-right">
               

            </div>
        </nav>
    );
};

export default Header;
